import { render, staticRenderFns } from "./TeamForm.vue?vue&type=template&id=5d5ce29b&"
import script from "./TeamForm.vue?vue&type=script&lang=ts&"
export * from "./TeamForm.vue?vue&type=script&lang=ts&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports